// extracted by css-extract-rspack-plugin
export default {"headerPillWrapper":"HeaderCellWithColumnInfo-module__headerPillWrapper___myWOV"};